<template>
  <section class="reg" ref="a" :style="{'background-image': 'url('+registerInfoForm.actBackgroundImgUrl+')'}">
    <div class="logo">
      <!-- <div class="fl"><img src="../../../assets/images/h5-logo-2x.png" /></div> -->
      <div class="fr" @click="changeRouterRule()">活动规则</div>
    </div>
    <div class="pri-text" :class="{ lg: coupons.length > 2 }">
      <img src="../../../assets/images/h5-gongxihuode-2x.png" />
    </div>
    <div class="coupon" :class="{ lg: coupons.length <= 3 }">
      <div class="item" v-for="(item, index) in coupons" :key="index">
        <div class="price">
          <div class="num" v-if="item.cpnType == 0">
            <b>{{ item.credit }}</b>元
          </div>
          <div class="num" v-else-if="item.cpnType == 1">
            <b>{{ item.credit }}</b>元
          </div>
          <div class="num" v-else-if="item.cpnType == 2">
            <b>{{ convertDiscont(item.discount) }}</b>折
          </div>
          <div>{{ formatDate(item.expireTime, "yyyy-MM-dd") }}到期</div>
        </div>
        <div class="remark" v-if="item.cpnType == 0">
          <b>{{item.actCpnName}}</b>
          <div>无门槛使用</div>
        </div>
        <div class="remark" v-else-if="item.cpnType == 1">
          <b>{{ item.actCpnName }}</b>
          <div>订单满{{ item.astrict || "0" }}元可用</div>
        </div>
        <div class="remark" v-else-if="item.cpnType == 2">
          <b>{{ item.actCpnName }}</b>
          <div>最高可抵扣{{ item.ceiling || "0" }}元</div>
        </div>
      </div>
    </div>

    <div class="footer" :class="{ fixed: coupons.length >= 3 }">
      <img :src="registerInfoForm.actButtonImgUrl" class="download-btn" @click="changeRouterDownload" />
      <!-- <button class="download-btn" @click="changeRouterDownload()">
        下载礼帽出行APP
      </button> -->
    </div>
  </section>
</template>

<script>
import { Toast } from "vant";
import { getCoupon, registerInfo } from "@/api/coupon";
import { formatDate } from "@/filters/index";

export default {
  data() {
    return {
      formatDate: formatDate,
      coupons: [
        // {"uuid":"c2e22ca6b49f484f823e5a75b3d90a81","actCpnName":null,"expireTime":1648742399000,"cpnType":2,"astrict":null,"credit":null,"discount":0.3,"ceiling":10.0,"actUuid":null,"expand":null},
        // {"uuid":"a531fd4ba347437f83cb20dd044a1f11","actCpnName":null,"expireTime":1649001599000,"cpnType":0,"astrict":null,"credit":100.0,"discount":null,"ceiling":null,"actUuid":null,"expand":null},
        // {"uuid":"9c9a08f6ea524187a0e9e8d308896284","actCpnName":null,"expireTime":1648742399000,"cpnType":2,"astrict":null,"credit":null,"discount":0.3,"ceiling":10.0,"actUuid":null,"expand":null},
        // {"uuid":"d06b267f78de4d7496e93a02ad1d8195","actCpnName":null,"expireTime":1649001599000,"cpnType":1,"astrict":10.0,"credit":30.0,"discount":null,"ceiling":null,"actUuid":null,"expand":null},
        // {"uuid":"7578f108acb744c2a6fe7df2e9e887cb","actCpnName":null,"expireTime":1648742399000,"cpnType":2,"astrict":null,"credit":null,"discount":0.3,"ceiling":10.0,"actUuid":null,"expand":null},
        // {"uuid":"e7289a6b14ff483dac92e62e987019ed","actCpnName":null,"expireTime":1648742399000,"cpnType":2,"astrict":null,"credit":null,"discount":0.3,"ceiling":10.0,"actUuid":null,"expand":null},
        // {"uuid":"6bbd82891600485f828169b0d0accb93","actCpnName":null,"expireTime":1649001599000,"cpnType":0,"astrict":null,"credit":100.0,"discount":null,"ceiling":null,"actUuid":null,"expand":null},
        // {"uuid":"6a5c90e058da4e8e8b7d64a47a407796","actCpnName":null,"expireTime":1649001599000,"cpnType":0,"astrict":null,"credit":100.0,"discount":null,"ceiling":null,"actUuid":null,"expand":null},
        // {"uuid":"628b44d100a440a48611f520dbf28cf5","actCpnName":null,"expireTime":1649001599000,"cpnType":1,"astrict":10.0,"credit":30.0,"discount":null,"ceiling":null,"actUuid":null,"expand":null},
        // {"uuid":"e83abcf3bf5f42a8a3c5ddb0da0116d0","actCpnName":null,"expireTime":1649001599000,"cpnType":1,"astrict":10.0,"credit":30.0,"discount":null,"ceiling":null,"actUuid":null,"expand":null},
        // {"uuid":"5dad333d3a3043eea865c4358f52a7a3","actCpnName":null,"expireTime":1649001599000,"cpnType":0,"astrict":null,"credit":100.0,"discount":null,"ceiling":null,"actUuid":null,"expand":null},
        // {"uuid":"5ba716df741b4f0a9fcbb46fbb0436ed","actCpnName":null,"expireTime":1649001599000,"cpnType":1,"astrict":10.0,"credit":30.0,"discount":null,"ceiling":null,"actUuid":null,"expand":null},
        // {"uuid":"01a46fc32415413cace604d5ddd8ba65","actCpnName":null,"expireTime":1649001599000,"cpnType":1,"astrict":10.0,"credit":30.0,"discount":null,"ceiling":null,"actUuid":null,"expand":null},
        // {"uuid":"f301d74e1e464f09b2bb371f4ee8d73a","actCpnName":null,"expireTime":1649001599000,"cpnType":1,"astrict":10.0,"credit":30.0,"discount":null,"ceiling":null,"actUuid":null,"expand":null},
        // {"uuid":"36a87975012049e4811466aee04e1c84","actCpnName":null,"expireTime":1649001599000,"cpnType":1,"astrict":10.0,"credit":30.0,"discount":null,"ceiling":null,"actUuid":null,"expand":null},
        // {"uuid":"f716731fe18a459ba38303f276026c95","actCpnName":null,"expireTime":1649001599000,"cpnType":1,"astrict":10.0,"credit":30.0,"discount":null,"ceiling":null,"actUuid":null,"expand":null},
        // {"uuid":"287ba893f5ac4d678f88bdf003aa68c0","actCpnName":null,"expireTime":1649001599000,"cpnType":0,"astrict":null,"credit":100.0,"discount":null,"ceiling":null,"actUuid":null,"expand":null},{"uuid":"283eeeb07e99449486112c1dd4ede589","actCpnName":null,"expireTime":1649001599000,"cpnType":1,"astrict":10.0,"credit":30.0,"discount":null,"ceiling":null,"actUuid":null,"expand":null},{"uuid":"1ebaafaa65e04002acc2218d9a8d389b","actCpnName":null,"expireTime":1649001599000,"cpnType":1,"astrict":10.0,"credit":30.0,"discount":null,"ceiling":null,"actUuid":null,"expand":null},{"uuid":"1eb35c9cf4514b448bf2265b505f1ec7","actCpnName":null,"expireTime":1649001599000,"cpnType":0,"astrict":null,"credit":100.0,"discount":null,"ceiling":null,"actUuid":null,"expand":null},{"uuid":"1cc78c1684a3466b856d9c98527028ed","actCpnName":null,"expireTime":1648742399000,"cpnType":2,"astrict":null,"credit":null,"discount":0.3,"ceiling":10.0,"actUuid":null,"expand":null},{"uuid":"c4d3dfce4369468790cb3d1245a8b75e","actCpnName":null,"expireTime":1648742399000,"cpnType":2,"astrict":null,"credit":null,"discount":0.3,"ceiling":10.0,"actUuid":null,"expand":null},{"uuid":"c837685bc39b4f6ba20cf2820d5ebd45","actCpnName":null,"expireTime":1649001599000,"cpnType":0,"astrict":null,"credit":100.0,"discount":null,"ceiling":null,"actUuid":null,"expand":null},{"uuid":"d05d05e45899429badea108cb8346f27","actCpnName":null,"expireTime":1648742399000,"cpnType":2,"astrict":null,"credit":null,"discount":0.3,"ceiling":10.0,"actUuid":null,"expand":null},{"uuid":"f950ae055c5f4b1588696f6ff7b28dfb","actCpnName":null,"expireTime":1649001599000,"cpnType":1,"astrict":10.0,"credit":30.0,"discount":null,"ceiling":null,"actUuid":null,"expand":null},{"uuid":"d87dd1570685488c9ebb6450a3dd20ae","actCpnName":null,"expireTime":1649001599000,"cpnType":0,"astrict":null,"credit":100.0,"discount":null,"ceiling":null,"actUuid":null,"expand":null},{"uuid":"da83a49b395d4818a52453d510be5e0d","actCpnName":null,"expireTime":1649001599000,"cpnType":0,"astrict":null,"credit":100.0,"discount":null,"ceiling":null,"actUuid":null,"expand":null},{"uuid":"f515dc2513fe42928b14c0e8e538e212","actCpnName":null,"expireTime":1649001599000,"cpnType":1,"astrict":10.0,"credit":30.0,"discount":null,"ceiling":null,"actUuid":null,"expand":null},{"uuid":"f0d2c1ed7aa641d38b93e4fca8ca0daf","actCpnName":null,"expireTime":1648742399000,"cpnType":2,"astrict":null,"credit":null,"discount":0.3,"ceiling":10.0,"actUuid":null,"expand":null},{"uuid":"e85c0906601340b2a3116bd7b60327a5","actCpnName":null,"expireTime":1649001599000,"cpnType":1,"astrict":10.0,"credit":30.0,"discount":null,"ceiling":null,"actUuid":null,"expand":null},{"uuid":"bdbdd480c1d54716ab1e8231eb8c4eac","actCpnName":null,"expireTime":1649001599000,"cpnType":0,"astrict":null,"credit":100.0,"discount":null,"ceiling":null,"actUuid":null,"expand":null},{"uuid":"a9ef78c8e6ad41ebbffc6d05819a97ea","actCpnName":null,"expireTime":1649001599000,"cpnType":0,"astrict":null,"credit":100.0,"discount":null,"ceiling":null,"actUuid":null,"expand":null},{"uuid":"a64d816439f74dee9c844767d0a37062","actCpnName":null,"expireTime":1648742399000,"cpnType":2,"astrict":null,"credit":null,"discount":0.3,"ceiling":10.0,"actUuid":null,"expand":null},{"uuid":"a5cc4a013d564ef9bc7dbed5107d5698","actCpnName":null,"expireTime":1649001599000,"cpnType":1,"astrict":10.0,"credit":30.0,"discount":null,"ceiling":null,"actUuid":null,"expand":null},{"uuid":"831825a6506e49fc8cd63149f6f74cb4","actCpnName":null,"expireTime":1649001599000,"cpnType":1,"astrict":10.0,"credit":30.0,"discount":null,"ceiling":null,"actUuid":null,"expand":null},{"uuid":"6d1aad29c4124b96860915c4a6021558","actCpnName":null,"expireTime":1649001599000,"cpnType":0,"astrict":null,"credit":100.0,"discount":null,"ceiling":null,"actUuid":null,"expand":null},{"uuid":"61fda20a59b149268d4635a4128b6cb5","actCpnName":null,"expireTime":1649001599000,"cpnType":1,"astrict":10.0,"credit":30.0,"discount":null,"ceiling":null,"actUuid":null,"expand":null},{"uuid":"5135eb0d471f4c5eb5a03afa40c28991","actCpnName":null,"expireTime":1648742399000,"cpnType":2,"astrict":null,"credit":null,"discount":0.3,"ceiling":10.0,"actUuid":null,"expand":null},{"uuid":"3fa86fd9682a4e9fbf61e286c82589a2","actCpnName":null,"expireTime":1649001599000,"cpnType":1,"astrict":10.0,"credit":30.0,"discount":null,"ceiling":null,"actUuid":null,"expand":null},{"uuid":"38f85d00603642bc9d5faeb1057d3195","actCpnName":null,"expireTime":1649001599000,"cpnType":1,"astrict":10.0,"credit":30.0,"discount":null,"ceiling":null,"actUuid":null,"expand":null},{"uuid":"2e01c1aa65094a35a0d08be2fa444928","actCpnName":null,"expireTime":1649001599000,"cpnType":1,"astrict":10.0,"credit":30.0,"discount":null,"ceiling":null,"actUuid":null,"expand":null},{"uuid":"03987a2a8958416c80f747b7a82f1777","actCpnName":null,"expireTime":1649001599000,"cpnType":1,"astrict":10.0,"credit":30.0,"discount":null,"ceiling":null,"actUuid":null,"expand":null},{"uuid":"8a10566a35954d5b8271778caadb9c3b","actCpnName":"满10减30","expireTime":1648915199000,"cpnType":1,"astrict":10.0,"credit":30.0,"discount":null,"ceiling":null,"actUuid":null,"expand":null},{"uuid":"3b99e195f0fb4689bb39d7264b08fe04","actCpnName":"满10减30","expireTime":1648915199000,"cpnType":1,"astrict":10.0,"credit":30.0,"discount":null,"ceiling":null,"actUuid":null,"expand":null},{"uuid":"84a037463a474e9daa15b49f9128218f","actCpnName":"折扣券","expireTime":1648655999000,"cpnType":2,"astrict":null,"credit":null,"discount":0.3,"ceiling":10.0,"actUuid":null,"expand":null}
      ],
      registerInfoForm: {
        uuid: "",
        actUuid: "",
        actNo: "",
        activityQuota: 0,
        status: undefined,
        ticketStatus: undefined
      }
    };
  },
  components: {},
  created() {
    this.$store.commit("loading/HIDELOADING");
    this.getRegisterInfo()
    this.getCoupon();
  },
  mounted(){
    console.log(this.$refs.a);
  },
  methods: {
    convertDiscont(num) {
      if (!num) {
        return "-";
      }
      return Number((num*10).toFixed(2))
    },
    getCoupon() {
      getCoupon({
        mobile: this.$route.query.mobile,
        ticketUuid: this.$route.query.ticketUuid
      }).then((res) => {
        if (res.returnCode === 10000) {
          this.coupons = res.data;
          console.log(this.coupons)
        } else {
          Toast(res.msg);
        }
      });
    },
    getRegisterInfo() {
      let ticketUuid = this.$route.query.ticketUuid;
      registerInfo({ ticketUuid }).then(res=>{
        this.registerInfoForm = res.data
      })
    },
    changeRouterRule() {
      this.$router.push({
        path: "/coupon-rule",
        query: {
          id: this.$route.query.ticketUuid,
        },
      });
    },
    changeRouterDownload() {
      // sendDownload({ 
      //   regActUuid: this.$route.query.regActUuid,
      // });
      // window.location.href = "/download.html";
      window.location.href = this.registerInfoForm.actButtonReferUrl;
    },
  },
};
</script>

<style scoped lang="scss">
body {
  background-color: #ffec00;
}
.reg {
  position: relative;
  width: 100%;
  height: 100%;

  // background: url("../../../assets/images/reg-suc-bg-2x.png") no-repeat;
  background-size: 100%;
  background-repeat: no-repeat;

  .logo {
    padding: 20px 24px;
    color: #ffd9b8;
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    img {
      height: 30px;
    }
    .fl {
      float: left;
    }
    .fr {
      float: right;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #000000;
      line-height: 20px;
    }
  }
  .pri-text {
    margin-bottom: 20px;
    margin-top: 0px;
 
    &.lg {
      margin-bottom: 0px;
      margin-top: -8px;
    }
    img {
      width: 90%;
      visibility:hidden;
    }
  }
  .coupon {
    width: 90%;
    margin: 0 auto;
    margin-top: -4px;
    // height: calc(100% - 335px);
    overflow-y: scroll;
    &.lg {
      height: auto;
      margin-top: 0px;
    }
    .item {
      width: 100%;
      height: 107px;
      background: url("../../../assets/images/youhuiquan-big@2x.png") no-repeat;
      background-size: 100% 100%;
      box-sizing: border-box;
      display: flex;
      align-items: center;
      margin-bottom: 8px;
      .price {
        width: 43%;
        font-size: 12px;
        font-weight: 400;
        font-family: PingFangSC-Regular, PingFang SC;
        color: #aaa;
        line-height: 12px;
        margin-top: -11px;
        .num {
          height: 44px;
          margin-bottom: 2px;
          b {
            font-size: 44px;
            font-weight: bold;
            color: #222;
            line-height: 44px;
          }
          font-size: 16px;
          font-weight: 600;
          color: #222;
          line-height: 16px;
        }
      }
      .remark {
        width: 53%;
        padding-left: 4%;
        font-size: 14px;
        font-weight: 400;
        color: #999;
        font-family: PingFangSC-Regular, PingFang SC;
        line-height: 14px;
        text-align: left;
        b {
          margin-bottom: 6px;
          display: inline-block;
          font-size: 18px;
          font-weight: 700;
          color: #222;
          line-height: 22px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          display: inline-block;
          max-width: 98%;
        }
      }
    }
  }
  @media screen and (max-height: 1200px) {
    .footer {
      margin: 31px auto 40px;
    }
    .coupon {
      height: calc(100% - 280px);
    }
    .fixed {
      margin: 0 auto 36px;
    }
  }
  @media screen and (min-height: 600px) {
    .footer {
      margin: 62px auto 40px;
    }
    .coupon {
      height: calc(100% - 321px);
    }
    .fixed {
      margin: 0 auto 40px;
    }
  }
  .footer {
    // margin-top: -36px;
    // margin: 62px auto 40px;
    > div {
      margin: 62px auto 40px;
      font-size: 14px;
      font-weight: 400;
      color: #866b5d;
      line-height: 20px;
    }
    &.fixed {
      position: fixed;
      bottom: 0;
      left: 0;
      width: 100%;
      //   margin: 0 auto 40px;
      //   padding: 18px 30px 40px;
      //   background: url("../../../assets/images/h5-mask-2x.png") no-repeat;
      //   background-size: cover;
    }
  }
  .download-btn {
    // margin: 0 auto 24px;
    width: 85%;
    height: 50px;
    // font-size: 16px;
    // font-family: PingFangSC-Regular, PingFang SC;
    // font-weight: 400;
    // color: #ffec00;
    // line-height: 22px;
    // background: url("../../../assets/images/h5-btn-2x.png") no-repeat;
    // background-size: 100% 100%;
    // border: none;
  }
}

</style>
